export default {
  common: {
    nav: {
      home: "Inicio",
      find_offer_help: "Buscar / Ofrecer ayuda",
      celebrate: "Celebrar una vida",
      family_tree: "Árbol genealógico",
      events: "Eventos",
      civic_reports: "Informes cívicos",
      neighborhood_pulse: "Pulso del barrio",
      weather: "Clima",
      nature: "Naturaleza",
      marketplace: "Mercado",
      news: "Noticias",
      causes: "Causas",
      more: "Más",
    },
    header: { sign_in: "Iniciar sesión", join: "Unirse a Social Pulse", language: "Idioma", search: "Buscar" },
    tagline: "Conectando comunidades · Empoderando vidas · Construyendo capital social",
    locality: {
      viewing_from: "Estás viendo desde",
      help_improve: "Ayúdanos a mejorar tu ubicación",
      filter_by_country: "Filtrar por país",
      change: "Cambiar",
      set_your_location: "Establece tu ubicación",
      set_your_location_hint: "— toca para personalizar",
    },
    actions: {
      submit_cause: "Enviar una causa / petición",
      make_donation: "Apoya las iniciativas globales de Social Pulse — Haz una donación",
      browse_all: "Ver todas las secciones",
    },
    news: {
      title: "Tu resumen diario.",
      submit_news: "Enviar noticia",
      archive: "Archivo",
      weather_nature: "Clima y naturaleza",
      play_briefing: "Reproducir resumen diario",
      play_briefing_hint: "Escucha las {{count}} noticias principales · ~{{minutes}} min · en tu idioma",
      read_original: "Leer original",
      view_brief: "Ver resumen",
      also_reported_by: "También informado por:",
      translate: "Traducir",
      listen: "Escuchar",
      stop: "Detener",
    },
  },
};
